// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditClaim from '@deere/cps-it.warranty-model-factory/lib/audit-claim';
import AuditClaimListItem from './audit-claim-list-item';
import {FormattedMessage} from 'react-intl';

function handleOnClick() {

    this.onRemoveFromAudit(this.item);

}

const PrepareAuditListItem = props =>
    <AuditClaimListItem {...props}>
        {!props.item.isSystemSelected &&
            <footer>
                <button
                    className='secondary'
                    onClick={props::handleOnClick}
                >
                    <FormattedMessage id='REMOVE_FROM_AUDIT'/>
                </button>
            </footer>
        }
    </AuditClaimListItem>;

PrepareAuditListItem.displayName = 'PrepareAuditListItem';
PrepareAuditListItem.propTypes = {
    item: PropTypes.instanceOf(AuditClaim).isRequired,
    onRemoveFromAudit: PropTypes.func
};

export default PrepareAuditListItem;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/prepare-audit-list-item.js